<template>
  <div class="has-text-centered">
    <div class="m-b-sm">
      <div class="has-text-centered">
        <router-link :to="{ name: 'Home' }">
          <img v-if="$store.getters.isMH" src="@/../static/muscle_heroes_logo.svg" class="is-inline-block is-xlarge icon" />
          <img v-else src="@/../static/keepyou.fit.svg" class="is-inline-block is-xlarge icon" />
        </router-link>
      </div>
      <span class="m-t-md m-r-md menu-icon" @click="showMenu" style="position: absolute;right: 0;top: 0;">
        <img v-if="$store.getters.isMH" src="@/../static/svg/cancel.svg" class="is-inline-block is-large icon">
        <img v-else src="@/../static/kfit/cancel.svg" class="is-inline-block is-large icon" />
      </span>
      <WorkoutMenu ref="menu" :show="false" @resume="resume"  @save="save"  @stop="stop" @hide="playPause" />
      <Counter ref="cnt" v-show="isCounter" :from="counter" v-on:end="next" />
  </div>
    <p class="is-size-4 is-uppercase has-text-primary">{{ 'Workouts' | translate }}</p>
    <p class="is-size-3 is-uppercase lh-1">{{ currentTraining.groups.length }} {{ 'workouts with' | translate }}<br>{{ currentTraining.repetitions.length }} {{ 'repetitions' | translate }}</p>
    <Workout :key="currentTraining.name" ref="workout" :list="currentTrainingWorkouts" :rep="currentTraining.repetitions.length" @progress="progress" @end="end" @playing="setPlaying" class="m-t-md">
    </Workout>
    <div class="columns is-mobile p-l-md p-r-md is-size-4 p-t-sm p-b-none">
      <div class="column is-4 has-text-left p-b-none">
        {{ fullTimeInMinute }}
      </div>
      <div class="column is-4 has-text-centered p-b-none">
        {{ current + 1 }} / {{ countWorkout }}
      </div>
      <div class="column is-4 has-text-right p-b-none">
        LV: {{ currentTraining.level }}
      </div>
    </div>
    <hr class="has-background-primary" style="height:1px;">
    <p style="padding-bottom:1.5rem">{{ $t('Individual exercises') }}</p>
    <div class="card" v-for="(item, i) in currentTrainingWorkouts" :key="item.vidname + i">
      <div class="card-content">
        <div class="media" @click="showExample(item)">
          <div class="media-left">
            <figure class="image" style="width: 128px;">
              <img :src="item.preview" :alt="item.name">
            </figure>
          </div>
          <div class="media-content">
            <p class="title is-4">{{ item.name }}</p>
          </div>
        </div>
      </div>
    </div>
    <br class="m-b-xl">
    <div class="has-background-dark" style="position:fixed;left:0;right:0;bottom:0;">
        <div @click="playPause" class="is-fullwidth has-background-primary has-text-white has-text-centered p-sm is-size-3">
          <span v-show=" ! playing">{{ $t('Start training') }}! </span>
          <img v-show=" ! playing" src="@/../static/svg/play.svg" class="icon" style="height: 3rem;width: 3rem;margin-bottom:-0.75rem !important">
          <span v-show="playing" class="icon has-text-light is-size-2" style="height: 2.75rem;width: 2.75rem;">
            <i class="fa fa-pause"></i>
          </span>
        </div>
      <Footer />
    </div>
    <div :class="'modal ' + (exampleIsActive ? 'is-active' : 'not-active')" @click="hideExample">
      <div class="modal-background"></div>
      <div class="modal-content">
        <Video ref="example" viewmode="vimeo" :src="exampleVideoSrc" :key="exampleKey" :poster="exampleVideoPoster" ></Video>
      </div>
      <button class="modal-close is-large" aria-label="close"></button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Footer from '@/components/Footer'
import Header from '@/components/Header'
import Workout from '@/components/Settings/WorkoutM'
import WorkoutMenu from '@/components/Settings/WorkoutMenu'
import Counter from '@/components/Settings/Counter'
import Video from '@/components/Settings/VideoM'


export default {
  name: 'Training',
  data () {
    let currentTraining = {}
    if (this.$route.query.tn !== undefined) {
      currentTraining = this.$store.getters.getTrainingByName(this.$route.query.tn) || {}
    }

    if (currentTraining.name === undefined && this.$store.getters.getCurrentTrainingName) {
      currentTraining = this.$store.getters.getTrainingByName(this.$store.getters.getCurrentTrainingName)
    } else if (currentTraining.name === undefined) {
      currentTraining = this.$store.getters.getRandomTraining(1)
      this.$store.commit('updateCurrentTrainingName', currentTraining.name)
    }
    return {
      current: 0,
      currentTime: 0,
      workoutTime: 0,
      currentWorkoutTime: 0,
      currentTraining,
      isCounter: false,
      counter: 10,
      playing: false,
      currentTrainingWorkouts: currentTraining.workouts,
      exampleIsActive: false,
      exampleVideoSrc: null,
      exampleVideoPoster: null,
      exampleKey: Math.random()
    }
  },
  computed: {
    fullTimeInMinute() {
      return Math.floor(this.fullTime/60) + ':' + ('0' + this.fullTime%60).slice(-2)
    },
    fullTime () {
      return this.currentTrainingWorkouts.reduce((sum, item) => sum + item.duration, 0) * this.currentTraining.repetitions.length + 10 * (this.currentTraining.repetitions.length * this.currentTrainingWorkouts.length - 1)
    },
    countWorkout () {
      return this.currentTrainingWorkouts.length * this.currentTraining.repetitions.length
    }
  },
  methods: {
    progress(obj) {
      this.current = obj.current
      this.currentTime = obj.currentTime,
      this.workoutTime = obj.workoutTime
      this.isCounter = obj.counter
      this.currentWorkoutTime = obj.currentWorkoutTime
      if (obj.counter) {
        this.$refs.cnt.start(10)
      }
    },
    playPause() {
      this.$scrollToTop(100)
      this.$refs.workout.playPause()
    },
    resume() {
      this.playPause()
    },
    save() {
      this.$router.push({ name: 'Home' })
    },
    stop() {
      this.$store.commit('setWorkoutNumber', 0)
      this.$router.push({ name: 'Home' })
    },
    next() {
      this.isCounter = false
      this.counter = 10
      this.playPause()
    },
    end() {
      console.log(this.currentTraining.name)
      if (this.currentTraining.isTraining) {
        this.$router.push({ name: 'TrainingEnd' })
      } else {
        this.$router.push({ name: 'Training' })
        if (this.$store.getters.getCurrentTrainingName) {
          this.currentTraining = this.$store.getters.getTrainingByName(this.$store.getters.getCurrentTrainingName)
        } else {
          this.currentTraining = this.$store.getters.getRandomTraining(1)
          this.$store.commit('updateCurrentTrainingName', this.currentTraining.name)
        }
        this.currentTrainingWorkouts = this.currentTraining.workouts
        this.current = 0
        this.currentTime = 0
        this.workoutTime = 0
        this.currentWorkoutTime = 0
      }
    },
    showMenu() {
      this.$refs.workout.pause()
      this.$refs.menu.showMe()
    },
    setPlaying (playing) {
      return this.playing = playing
    },
    showExample (example) {
      this.$router.push({ name: 'Training', query: {
        tn: example.name
      } })
      this.currentTraining = this.$store.getters.getTrainingByName(example.name)
      this.currentTrainingWorkouts = this.currentTraining.workouts
      this.current = 0
      this.currentTime = 0
      this.workoutTime = 0
      this.currentWorkoutTime = 0
      /*this.exampleVideoSrc = example.vidpath === undefined ? 'http://assets.keepyou.fit/fitness/vid/'+example.vidname+'.mp4' : example.vidpath
      this.exampleVideoPoster = example.preview
      this.exampleIsActive = true
      this.$refs.example.play()*/
    },
    hideExample() {
      this.$refs.example.pause()
      this.exampleKey = Math.random()
      this.exampleVideoSrc = null
      this.exampleVideoPoster = null
      this.exampleIsActive = false
    }
  },
  async mounted() {
    if (this.$store.getters.requireSaleId && window !== undefined && window.localStorage instanceof Storage && window.localStorage.getItem('saleId') !== null) {
      const result = await axios.get(`/${ this.$store.getters.apiPrefix }/checkSale/${ window.localStorage.getItem('saleId') }`)
      if (result.data.state === 'unknown') {
        this.$router.push({ name: 'LP' })
      }
    }
  },
  components: {
    Footer,
    Header,
    Workout,
    WorkoutMenu,
    Counter,
    Video
  }
}
</script>

<style>
.preview {
  display: inline-block;
  margin: 0.5rem 1rem;
  border-radius: 0.5rem;
}
.play {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -16px;
  margin-top: -16px;
}
</style>





// WEBPACK FOOTER //
// src/components/Settings/TrainingMen.vue